<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo">
        <img src="../../common/images/logo-white.png"/>
      </div>
      <div class="top">
        <div class="bg"></div>
        <span>用户登录</span>
      </div>
      <div class="bottom">
        <div class="p">
          <el-input v-model="obj.username" placeholder="请填写用户名" prefix-icon="el-icon-s-custom">
          </el-input>
        </div>
        <div class="p">
          <el-input type="password" v-model="obj.password" placeholder="请填写密码"
                    prefix-icon="el-icon-lock"></el-input>
        </div>
        <div class="p">
          <el-button @click="_login">登 录</el-button>
        </div>
        <!--<div class="p mb-10">-->
        <!--<el-input placeholder="请输入内容" prefix-icon="el-icon-key"></el-input>-->
        <!--</div>-->
      </div>
    </div>

    <div class="dynamic-area1"></div>
    <div class="bg"></div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {api} from '../../common/js/api.js';
  import {tool} from "../../common/js/tool.js";
  export default {
    data() {
      return {
        canDo: true,
        verifyUrl: "",
        obj: {
          username: "",
          password: "",
        }
      };
    },

    computed: {},

    created() {
      window.onkeydown = e => {
        if (e.keyCode === 13) {
          this._login();
        }
      };
    },

    methods: {
      _login() {
//        let obj = Object.assign({}, this.obj);
//        api.user.login(this.obj).then((res) => {
//          console.log(res);
//        })
//        return;
//        console.log(obj);
        tool.message("登录成功", "success", () => {
          tool.setCookie("token", "token");
          tool.setCookie("navActive", "0-0");
          this.$store.commit("setTabActive", "0-0");
          this.$store.commit("setTabs", [
            {
              pageMenu: "首页",
              index1: 0,
              index2: 0,
              pageUrl: "/home",
              active: true
            }
          ]);
          this.$router.push({path: "/monitoring/realtime"});
        });
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import url("../../common/less/variable.less");

  .login-container {
    .login-box {
      width: 380px;
      height: 255px;
      background: rgba(57, 154, 249, 0.4);
      box-shadow: 0 1px 8px 0 rgba(0, 28, 55, 0.3);
      border: solid 1px rgba(255, 255, 255, 0.18);
      position: fixed;
      right: 10%;
      top: 40%;
      z-index: 9;
      margin-top: -132px;
      .logo {
        position: absolute;
        top: -50px;
        left: 0;
        width: 380px;
        text-align: center;
        img {
          width: 300px;
        }
      }
      .top {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        position: relative;
        span {
          font-size: 20px;
          color: white;
          position: relative;
          z-index: 1;
        }
        .bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 50px;
          background-image: linear-gradient(0deg, #0e74a3 81%, #f7fafa 100%),
          linear-gradient(#99c6ff, #99c6ff);
          background-blend-mode: multiply, normal;
          box-shadow: inset 0 2px 2px 0 #ffffff;
          opacity: 0.2;
        }
      }
      .bottom {
        padding: 20px;
        .p {
          display: flex;
          height: 40px;
          line-height: 40px;
          width: 100%;
          margin-bottom: 20px;
          .el-input__inner {
            border-radius: 0;
            height: 40px;
            line-height: 40px;
          }
          .el-button {
            border-radius: 0;
            height: 40px;
            line-height: 40px;
            padding: 0;
            width: 100%;
            cursor: pointer;
            font-size: 18px;
          }
        }
      }
    }
  }

  .bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url("../../common/images/login-bg.jpg") no-repeat;
    background-size: 100% 100%;
  }

  .dynamic-area1 {
    position: fixed;
    width: 100%;
    height: 300px;
    top: 0;
    left: 0;
    z-index: 1;
    background: url("../../common/images/yun.png") repeat-x 0 0;
    /*background-size: cover;*/
    animation: across 1500s linear infinite;
    opacity: 0.1;
  }

  @keyframes across {
    from {
      background-position: 0 0;
    }
    to {
      background-position: 4000% 0;
    }
  }
</style>
